<template>
    <div class="split content split-horizontal second-wishlist chartIQ" id="charScreeen" :class="$route.name == 'chart-iq'?'demo-chart-iq m-0 w-100':''" :style="$route.name == 'chart-iq'?'height: 100vh !important;':''" @click.stop.prevent="">
        <div class="hanko-chartIQ">
            <cq-context id="ch-iq">
                <div class="d-none">{{ changeChartBidPrice }}-{{ getSum }}-{{ checkWS }}</div>
                <!-- <cq-chart-instructions></cq-chart-instructions> -->
                <!--  Begin Navbar -->
                <div class="ciq-nav full-screen-hide" role="navigation">
                    <!-- enables the more button when in break-sm mode -->
                    <div class="sidenav-toggle ciq-toggles">
                        <cq-toggle class="ciq-sidenav" member="sidenav" toggles="sidenavOn,sidenavOff" toggle-classes="active," reader="More Options" tooltip="More" icon="morenav"></cq-toggle>
                    </div>
                    <cq-toggle class="ciq-lookup-icon" config="symbolsearch" reader="Symbol Search" tooltip="Symbol Search" icon="search" help-id="search_symbol_lookup"></cq-toggle>
                    <cq-toggle class="ciq-comparison-icon" config="symbolsearch" reader="Add Comparison" tooltip="Add Comparison" icon="compare" help-id="add_comparison" comparison="true"></cq-toggle>
                    <!-- any entry in this div will be shown in the side navigation bar in break-sm mode -->
                    <cq-side-nav cq-on="sidenavOn">
                        <div class="icon-toggles ciq-toggles">
                            <cq-toggle class="ciq-draw" member="drawing" reader="Draw" tooltip="Draw" icon="draw" help-id="drawing_tools_toggle"></cq-toggle>
                            <cq-toggle class="ciq-CH" config="crosshair" reader="Crosshair" tooltip="Crosshair (Alt + \)" icon="crosshair"></cq-toggle>
                            <cq-menu class="nav-dropdown toggle-options" reader="Crosshair Options" config="crosshair"></cq-menu>
                            <cq-toggle class="ciq-HU" feature="tooltip" config="info" reader="Info" tooltip="Info" icon="info"></cq-toggle>
                            <cq-menu feature="tooltip" class="nav-dropdown toggle-options" reader="Info Options" config="info"></cq-menu>
                            <cq-toggle class="ciq-DT" feature="tableview" member="tableView" reader="Table View" tooltip="Table View" icon="tableview"></cq-toggle>
                        </div>
                    </cq-side-nav>
                    <div class="ciq-menu-section">
                        <div class="ciq-dropdowns">
                            <cq-menu class="nav-dropdown ciq-display" reader="Display" config="display" binding="Layout.chartType" icon="" help-id="display_dropdown" tooltip=""></cq-menu>
                            <cq-menu class="nav-dropdown ciq-period" reader="Periodicity" config="period" text="" binding="Layout.periodicity"></cq-menu>
                            <cq-menu class="nav-dropdown ciq-views alignright-md alignright-sm" config="views" text="Views" icon="views" responsive="" tooltip="Views"></cq-menu>
                            <cq-menu class="nav-dropdown ciq-studies alignright" cq-focus="input" config="studies" text="Studies" icon="studies" responsive="" tooltip="Studies"></cq-menu>
                            <cq-menu class="nav-dropdown ciq-markers alignright" config="markers" text="Events" icon="events" responsive="" tooltip="Events"></cq-menu>
                            <cq-menu class="nav-dropdown ciq-preferences alignright" reader="Preferences" config="preferences" icon="preferences" tooltip="Preferences"></cq-menu>
                        </div>
                        <div class="ciq-toggles"></div>
                    </div>
                </div>
                <!-- End Navbar -->
    
                <div class="ciq-chart-area" role="main">
                    <div class="ciq-chart">
                        <cq-message-toaster default-display-time="10" default-transition="slide" default-position="top"></cq-message-toaster>
    
                        <cq-palette-dock>
                            <div class="palette-dock-container">
                                <cq-drawing-palette class="palette-drawing grid palette-hide" docked="true" orientation="vertical" min-height="300" cq-drawing-edit="none" cq-keystroke-claim=""></cq-drawing-palette>
                                <cq-drawing-settings class="palette-settings" docked="true" hide="true" orientation="horizontal" min-height="40" cq-drawing-edit="none"></cq-drawing-settings>
                            </div>
                        </cq-palette-dock>
    
                        <div class="chartContainer" ref="chartContainer"> 
                            <!-- tooltip markup is required only if addon tooltip is used and customization is required -->
                            <table class="hu-tooltip">
                                <caption>
                                    {{$t('tooltip') }} 
                                </caption>
                                <tbody>
                                    <tr hu-tooltip-field="" class="hu-tooltip-sr-only">
                                        <th>{{$t('field') }} </th>
                                        <th>{{$t('value') }} </th>
                                    </tr>
                                    <tr hu-tooltip-field="DT">
                                        <td class="hu-tooltip-name">{{$t('date_time') }} </td>
                                        <td class="hu-tooltip-value"></td>
                                    </tr>
                                    <tr hu-tooltip-field="Close">
                                        <td class="hu-tooltip-name"></td>
                                        <td class="hu-tooltip-value"></td>
                                    </tr>
                                </tbody>
                            </table>
    
                            <cq-chart-title cq-marker="" cq-browser-tab="" cq-activate-symbol-search-on-click=""></cq-chart-title>
    
                            <!-- Full-screen icons -->
                            <cq-marker class="chart-control-group full-screen-show">
                                <cq-toggle class="ciq-lookup-icon" config="symbolsearch" reader="Symbol Search" tooltip="Symbol Search" icon="search" help-id="search_symbol_lookup"></cq-toggle>
                                <cq-toggle class="ciq-comparison-icon" config="symbolsearch" reader="Add Comparison" tooltip="Add Comparison" icon="compare" help-id="add_comparison" comparison="true"></cq-toggle>
                                <cq-toggle class="ciq-draw" member="drawing" reader="Draw" icon="draw" tooltip="Draw" help-id="drawing_tools_toggle"></cq-toggle>
                                <cq-toggle class="ciq-CH" config="crosshair" reader="Crosshair" icon="crosshair" tooltip="Crosshair (Alt + \)"></cq-toggle>
                                <cq-toggle class="ciq-DT" feature="tableview" member="tableView" reader="Table View" icon="tableview" tooltip="Table View"></cq-toggle>
                                <cq-menu class="nav-dropdown ciq-period full-screen" config="period" text="" binding="Layout.periodicity"></cq-menu>
                            </cq-marker>
    
                            <cq-study-legend class="hovershow" marker-label="Signals" filter="signal" cq-marker=""></cq-study-legend>
                            <cq-study-legend class="hovershow" marker-label="Plots" clone-to-panel="" filter="panel" button-remove="true" series="true" cq-marker=""></cq-study-legend>
    
                            <cq-loader></cq-loader>
                        </div>
                    </div>
                </div>
    
                <!-- Markers/Events -->
                <cq-abstract-marker cq-type="helicopter"></cq-abstract-marker>
    
                <!-- Attribution component -->
                <cq-attribution></cq-attribution>
    
                <!-- Begin Footer -->
                <div role="complementary" class="ciq-footer full-screen-hide">
                    <!-- <div class="d-flex align-items-center px-3" @click="$router.back()">
                    </div> -->
                    <cq-toggle feature="shortcuts" member="session.shortcuts" class="ciq-shortcut-button bottom" stxtap="Layout.showShortcuts()" reader="Toggle Shortcut Legend" icon="shortcuts" tooltip="Shortcuts"></cq-toggle>
                    <cq-toggle feature="help" member="session.help" class="ciq-help-button bottom" stxtap="Layout.toggleHelp()" reader="Toggle Interactive Help" icon="help" tooltip="Interactive Help"></cq-toggle>
                    <cq-show-range config="range" role="group" aria-labelledby="label_showRange"></cq-show-range>
                </div>
                <!-- End Footer -->
    
                <cq-dialogs>
                    <cq-dialog>
                        <cq-drawing-context></cq-drawing-context>
                    </cq-dialog>
    
                    <cq-dialog>
                        <cq-study-context></cq-study-context>
                    </cq-dialog>
                </cq-dialogs>

                <div class="context-menu" id="context-menu" v-show="rightClickWindow" :style="{'top': rightClickWindowTop, right : '60px' }">
                    <ul>
                        <li v-for="(activeOrder, value) in activeOrderType" @click="openTrade(lastIsin, priceFromChart, activeOrder['orderType'], activeOrder['buySellType'])">
                            {{activeOrder['name']}} 0.01 {{lastIsin}} {{$t('at') }}  {{priceFromChart}}
                        </li>
                    </ul>
                </div>
                <div v-if="plotted.length!=0">
                    <div v-for="tradeid in plotted" :id="`drag_${tradeid}`" :key="tradeid" @mousedown="startDrag(tradeid, $event)" :style="{background: 'var(--default-topbar)', position:'absolute', 'z-index':1, 'left': tradeData[tradeid]['x']+ 'px', 'top': tradeData[tradeid]['y']+ 'px', border: `1px solid ${product == 'Capital-Street' ? 'var(--green-color)' : 'var(--green)'}`}" class="open_trade_chart">
                        <b class="float-left px-2" :id="`open_trade_${tradeid}`">{{$t('pnl_s') }}  </b>
                        <div class="float-left px-2">{{ tradeData[tradeid]['comment']?`${tradeData[tradeid]['comment']} ${getTradeQty(tradeData[tradeid])}`:'-' }}</div>
                        <div class="float-left px-2" role="button" @click="closeTradeFromChart(tradeid)" data-toggle="tooltip" data-placement="top" title="Close Position">
                            <feather size="12px" type="x"></feather>
                        </div>
                    </div>
                </div>
                <!-- <cq-side-panel></cq-side-panel> -->
            </cq-context>
        </div>
    </div>
</template>
<script>
import moment from 'moment'
import { Const } from '@/plugins/vue-provider-cache/const.mod'
import { commonAllmixins } from "@/plugins/commonAll";
import "../../../../static/website/chartiq/plugins/tfc/tfc-demo.js";
const product_type = process.env.product_type;
const product = process.env.product;
import isEqual from 'lodash/isEqual';
import { normalizeKeys } from '../../../store/commomFunction.js';
// import { CIQ } from "../../../../static/website/chartiq/js/chartiq.js";
// import { CIQ, quoteFeed, symbolLookupBase } from "../../../../static/website/chartiq/js/standard.js";
// import "../../../../static/website/chartiq/plugins/tfc/tfc.js";
// import "../../../../static/website/chartiq/plugins/tfc/tfc-demo.js";
// import startActiveTrader from "@/store/chart-iq-active-trades.ts";
// import startActiveTrader from "../../../../static/website/chartiq/plugins/activetrader/activetrader.js";
    export default {
        mixins: [commonAllmixins],
        data(){
            return{
                isin : "GBPUSD"+product_type,
                lastIsin : "",
                stxx: null,
                product,
                timer : 0,
                prevTime: '',
                showLine: false,
                isSleep: false,
                timeFrame : '',
                frametype : {
                    '1day': 'YYYYMMDD0000',
                    '1m': 'YYYYMMDDHHmm',
                    '5m': 'YYYYMMDDHHmm',
                    '30m': 'YYYYMMDDHHmm',
                },
                priceFromChart: 0,
                rightClickWindowLeft:0,
                rightClickWindowTop:0,
                rightClickWindow: false,
                activeOrderType:{},
                lastPrice : 0,


                plotted:[],
                closedManually:[],
                tradeData:{},
                draggedTradeId: null,
                initialX: 0,
                dragging: false,
                sideValue:{
                    '0':'Sell',
                    '1':'Buy',
                },
                tempOrderId : [],
                previousDrawings:[],
                askMarker : null,
                bgColor:'',
                textColor:''
            }
        },
        props:['loadChart','mn'],
        emits:['placeTrade','changeChart'],
        computed:{
            getSum(){
                let _that = this
                // let idList = this.openTradeList.map(v=>v.Commentary.includes(this.providerId))
                let TradeID = this.openTradeList.map(v=>v.TradeID);
                let removedElements = [];
                let plotted = this.plotted.filter(item => TradeID.includes(item) || removedElements.push(item));
                if(removedElements.length){
                    removedElements.forEach(v=>{
                        if(!this.closedManually.includes(v)){
                            // console.log('---------removedElements------>',removedElements)
                            this.closedManually.push(v)
                            if (this.plotted.includes(v)) {
                                this.plotted.splice(this.plotted.indexOf(v), 1);
                            }
                        }
                    })
                    // this.closedManually = [...new Set([...this.closedManually, ...removedElements])];
                }
                // console.log('-------plotted--',plotted)
                const result = this.openTradeList.reduce((acc, item) => {
                    // if(!_that.delTrade.includes(item.TradeID)){
                        let curr = Number(_that.getPl(item,_that.instruments[item.Symbol]));
                        let el = document.getElementById("open_trade_"+item.TradeID)
                        if(this.accountList && item && el){
                            el.innerHTML=this.formatCurrency(curr, this.accountList.Currency);
                            (curr > 0)?(el.classList.remove('red'),el.classList.add('green')):'';
                            (curr < 0)?(el.classList.remove('green'),el.classList.add('red')):'';
                        }

                        acc.sumAll += curr;
                        acc.totalElements += 1;
        
                        if (curr > 0) {
                            acc.sumPositive += curr;
                            acc.totalPositive += 1;
                        } else if (curr < 0) {
                            acc.sumNegative += curr;
                            acc.totalNegative += 1;
                        }
                    // }

                    return acc;
                }, { 
                    sumPositive: 0, 
                    sumNegative: 0, 
                    sumAll: 0, 
                    totalPositive: 0, 
                    totalNegative: 0, 
                    totalElements: 0 
                });
                /*return {
                    'closeall':{ lengthOf : result.totalElements , sum :  result.sumAll },
                    'closeprofit':{ lengthOf : result.totalPositive , sum : result.sumPositive },
                    'closeloss':{ lengthOf : result.totalNegative , sum : result.sumNegative },
                }*/
               return ''
            },
            setLine(){
                let _that = this
                if(this.showLine){
                    if(_that.openTradeList.length > 0){
                        try{
                            // CIQ.ChartEngine.prototype.append("draw", function(){
                                _that.openTradeList.forEach((val,index) =>     {
                                    if(val.Symbol== _that.loadChart){
                                        _that.drawLine(val.Price, val.Side, 'solid',_that.getQuantity(val)) // "solid","dashed","dotted"
                                    }
                                    if(index == _that.openTradeList.length-1){
                                        // _that.chartReady = false
                                        // clearInterval(intervalData);
                                    }
                                })
                            // })
                        }catch(e){ }
                    }
                    if(_that.pendingOrderList.length > 0){
                        try{
                            // CIQ.ChartEngine.prototype.append("draw", function(){
                                _that.pendingOrderList.forEach((val,index) =>     {
                                    if(val.Type=='EL' || val.Type=='ES' && val.Symbol== _that.loadChart){
                                        _that.drawLine(val.Price, val.Side, 'dashed',_that.getQuantity(val)) // "solid","dashed","dotted"
                                    }
                                    if(index == _that.openTradeList.length-1){
                                        // console.log('this.chartReady ========> closed',_that.chartReady)
                                        // _that.chartReady = false
                                        // clearInterval(intervalData1);
                                        // console.log('intervalData closed')
                                    }
                                })
                            // })
                        }catch(e){ }
                    }
                }
                return '';
            },
            currency_pair(){
                return this.mn || this.isin;
            },
            instruments() {
                try {                    
                    this.$store.getters[Const.GET_HEARTBEATS]['priceFeed']
                    return this.$store.getters[Const.GET_PROVIDERS]['priceFeed'].iCache.asKeysValueArrayAll()
                } catch (ex) {                
                    return {}
                }
            },
            changeChartBidPrice_old(){
                let price_detail = this.instruments[this.lastIsin] || {};
                try{
                    const _that=this
                    let PSHFTB = Number(_that.priceShift[this.lastIsin+'B'] || 0)
                    if(this.stxx && price_detail.B && this.stxx.chart && !this.isSleep && this.lastPrice != price_detail.B){
                        // console.log(newQuotes,price_detail.B);
                        // this.stxx.addSeries("Ask", {color: "red", loadData: false, shareYAxis: true, step:true});
                        // this.stxx.addSeries("Bid", {color: "green", loadData: false, shareYAxis: true, step:true});
                        /*this.stxx.updateChartData({
                            Close : Number(price_detail.B),
                            Last :  Number(price_detail.B),
                            Bid :   Number(price_detail.B),
                            Ask :   Number(price_detail.A)
                            }, null, { useAsLastSale: true, secondarySeries: "Bid"});*/
                        if(this.stxx.chart.dataSet.length){
                            this.lastPrice = price_detail.B
                            // let newQuotes = this.stxx.chart.dataSet[this.stxx.chart.dataSet.length-1]
                            lastPrice != price_detail.B
                            // console.log(newQuotes,price_detail.B);
                            let price = Object.assign({}, price_detail);
                            // newQuotes.Close = Number(price_detail.B)
                            let momentDate = moment()
                            if(['5m','30m'].includes(this.timeFrame)){
                                let minutes = momentDate.minutes();
                                let timer = this.timeFrame == '30m'?30:5
                                let roundedMinutes = Math.floor(minutes / timer) * timer;
                                momentDate.minutes(roundedMinutes);
                            }
                            let dt = `${momentDate.format(this.frametype[this.timeFrame])}00000`
                            // console.log('Date',newQuotes.Date)
                            // console.log('dt',dt)
                            // console.log('format',this.frametype[this.timeFrame],this.timeFrame)
                            // console.log('this.stxx.chart',this.stxx.chart)
                            this.stxx.updateChartData({Date: dt,'Close':Number(price.B),'Bid':Number(price.B),'Ask':Number(price.A)})
                        }
                        // this.stxx.draw()
                        // this.stxx.updateChartData({ Bid:parseFloat(price_detail.A),Ask:parseFloat(price_detail.B) }, null, { useAsLastSale: true, secondarySeries: "Bid" });
                        // this.stxx.updateChartData({ Close:Number(price_detail.B) }, null, { useAsLastSale: true, secondarySeries: "Close" });
                        // var context = this.stxx.chart.context;
                        // context.fillStyle = "red";
                        // context.fillText("ASK: " + Number(price_detail.A), this.stxx.chart.width - 60, this.stxx.pixelFromPrice(Number(price_detail.A)));
                        // context.fillText( "", this.stxx.chart.width - 60, this.stxx.pixelFromPrice(Number(price_detail.A)));
                    }
                }catch(e){}
                return price_detail.B;
            },
            changeChartBidPrice(){
                if(product == 'Capital-Street'){
                    this.changeChartBidPrice_test;
                    return;
                }
                let price_detail = this.instruments[this.lastIsin] || {};
                const PSHFTB = Number(this.priceShift[this.lastIsin+'B'] || 0);
                const PSHFTB1 = Number(price_detail.PSHFTB || 0);
                if( this.stxx && price_detail.B && this.stxx.chart && !this.isSleep && PSHFTB === PSHFTB1 && this.lastPrice != price_detail.B){
                    // let newQuotes = this.stxx.chart.dataSet[this.stxx.chart.dataSet.length-1];
                    if(this.stxx.chart.dataSet.length){
                        this.lastPrice = price_detail.B
                        let ticksize = ((price_detail.other.Tick_Size || '').split('.')[1] || '').length;
                        let formatDigit = (v) =>{
                            return Number(Number(v).toFixed(ticksize))
                        }
                        let momentDate = moment()
                        if (['5m', '30m'].includes(this.timeFrame)) {
                            let timer = this.timeFrame === '30m' ? 30 : 5;
                            momentDate.minutes(Math.floor(momentDate.minutes() / timer) * timer);
                        }
                        let dt = `${momentDate.format(this.frametype[this.timeFrame])}00000`;
                        if( ['colored_line', 'line', 'vertex_line', 'step', 'mountain', 'baseline_delta'].includes(this.stxx.layout.chartType) ){
                            let date = new Date(momentDate)
                            date.setSeconds(0, 0);
                            this.stxx.updateChartData({ Date: dt, DT: date,'Close':formatDigit(price_detail.B),'Bid':formatDigit(price_detail.B),'Ask':formatDigit(price_detail.A) });
                        }else{
                            this.stxx.updateChartData({Date: dt,'Close':formatDigit(price_detail.B),'Bid':formatDigit(price_detail.B),'Ask':formatDigit(price_detail.A)})
                        }
                    }
                }
                return price_detail.B;
            },
            changeChartBidPrice_test(){
                let price_detail = this.instruments[this.lastIsin] || {};
                // const PSHFTB = Number(this.priceShift[this.lastIsin+'B'] || 0);
                // const PSHFTB1 = Number(price_detail.PSHFTB || 0);
                if( this.stxx && price_detail.B && this.stxx.chart && !this.isSleep && /*PSHFTB === PSHFTB1 &&*/ this.lastPrice != price_detail.B){
                    if(this.stxx.chart.dataSet.length){
                        this.lastPrice = price_detail.B
                        let ticksize = ((price_detail.other.Tick_Size || '').split('.')[1] || '').length;
                        let formatDigit = (v) =>{
                            return Number(Number(v).toFixed(ticksize))
                        }
                        // let momentDate = moment()
                        let momentDate = this.formatDateT(price_detail.T)
                        if (['5m', '30m'].includes(this.timeFrame)) {
                            let timer = this.timeFrame === '30m' ? 30 : 5;
                            momentDate.minutes(Math.floor(momentDate.minutes() / timer) * timer);
                        }
                        let dt = `${momentDate.format(this.frametype[this.timeFrame])}00000`;
                        if( ['colored_line', 'line', 'vertex_line', 'step', 'mountain', 'baseline_delta'].includes(this.stxx.layout.chartType) ){
                            let date = new Date(momentDate);
                            date.setSeconds(0, 0);
                            this.stxx.updateChartData({ Date: dt, DT: date,'Close':formatDigit(price_detail.B),'Bid':formatDigit(price_detail.B),'Ask':formatDigit(price_detail.A) });
                        }else{
                            this.stxx.updateChartData({Date: dt,'Close':formatDigit(price_detail.B),'Bid':formatDigit(price_detail.B),'Ask':formatDigit(price_detail.A)})
                        }
                    }
                }
                return price_detail.B;
            },
            checkWS(){
                let _that = this
                this.tempOrderId.forEach(val=>{
                    if(_that.wsOrder.hasOwnProperty(val)){
                        let msg = _that.wsOrder[val].resp_msg
                        let msgType = (_that.wsOrder[val].stat == 'OK')?'success':'error'
                        _that.displayError(msg,msgType)
                        _that.tempOrderId.splice(_that.tempOrderId.indexOf(val), 1)
                    }
                })
            },
            allow_ask_Line(){
                if(typeof(this.userSettings.display_ask_line) == 'number'){
					return this.userSettings.display_ask_line? true: false
				}else{
					return true;
				}
            },
            otherListObj(){
                return (this.currencyPairs || []).reduce((acc, item) => (acc[item.mn] = item, acc), {});
            }
	    },
        watch:{
            appTheme(val){
                if(this.stxx){
                    if(val){
                        // document.querySelector("cq-context").classList.remove('ciq-day');
                        // document.querySelector("cq-context").classList.add('ciq-night');
                        // if(process.env.product == 'Hanko'){
                        //     document.querySelector(".chartContainer").style.backgroundColor = "rgb(30,39,70)";
                        // }else{
                        //     document.querySelector(".chartContainer").style.backgroundColor = "rgb(28, 43, 53)";
                        // }
                        document.querySelector("cq-context").classList.add("ciq-night");
                        this.stxx.setThemeSettings();
                        var settings=CIQ.clone(CIQ.ThemeHelper.prototype.settings);
                        this.stxx.setThemeSettings(settings);
                    }
                    if(!val){
                        document.querySelector("cq-context").classList.remove('ciq-night');
                        document.querySelector("cq-context").classList.add('ciq-day');
                        document.querySelector(".chartContainer").style.backgroundColor = "rgb(255, 255, 255)";
                    }
                    // clear out the old styles to allow new ones to be cached in; and redraw.
                    this.stxx.styles={};
                    // this.stxx.loadCustom('ciq-night');
                    this.stxx.draw();
                    this.changeTheme()
                }
            },
            mn(val){
                if(val == this.lastIsin) return;
                this.plotted = [];
                if(this.stxx){
                    if (this.currency_pair) {
                    this.stxx.loadChart(this.currency_pair, {}, () => {
                        setTimeout(() => { 
                            const savedDrawings = localStorage.getItem(`${this.currency_pair}`);
                            if (savedDrawings) {
                                this.stxx.importDrawings(JSON.parse(savedDrawings));
                                this.stxx.draw(); 
                            }
                        }, 100);
                    });
                    }
                }
                let price_detail = this.instruments[this.currency_pair] || {};
                if(price_detail.other){
                    CIQ.ChartEngine.YAxis.prototype.decimalPlaces = ((price_detail.other.Tick_Size || '').split('.')[1] || '').length
                }
            },
       
        },
        created(){
            let _that = this
            // console.log(localStorage.getItem('myChartLayout'))
            // let currencyPairs = _that.currencyPairs.find(v=> v.mn == symbol);
            // this.store.getAccountBalance({},true);
            // this.store.getPositionList({},true,this)
            // this.store.getOrderList({},true,this);
            // this.subscribeISINS(this.currency_pair);
            let theme = localStorage.getItem("CIQ.Themes.prototype.current")
            if(theme){
                theme = JSON.parse(theme)
                // console.log('theme----->', theme)
                if(['ciq-night', 'ciq-day'].includes(theme.theme))
                    this.changeTheme();
            }else{
                this.changeTheme();
            }
            /*setInterval(()=>{
                // console.log(_that.stxx.tfc)
                try{
                    if(_that.stxx.tfc._isOpen){
                        _that.stxx.tfc.updateData();
                    }
                }catch(e){}
            }, 2000)*/
            
        },
        methods:{
            drawTradeLines() {
                const stx = this.stxx;
                let _that = this
                if (!stx) return;

                // Clean up previous event listeners
                stx.removeDrawings = stx.removeDrawings || [];
                stx.removeDrawings.forEach(fn => stx.removeEventListener("draw", fn));
                stx.removeDrawings = [];

                const drawAskLine = () => {
                    if(!_that.allow_ask_Line) return;
                    let price_detail = _that.instruments[_that.lastIsin] || {};
                    const askPrice = Number(price_detail.A); // 👈 Bind your ask price to this.ask
                    if (!askPrice) return;

                    const panel = stx.panels[stx.chart.panel.name];
                    if (!panel) return;

                    const lastTick = stx.chart.dataSet.length - 1;
                    const x0 = stx.pixelFromTick(0);
                    const x1 = stx.pixelFromTick(lastTick);
                    const y = stx.pixelFromValueAdjusted(panel, lastTick, askPrice);

                    // Style for ask line
                    const style = { color: "#FF0000", backgroundColor: "#FF0000", width: 1 };
                    stx.startClip(panel.name);
                    stx.plotLine( x0, x1, y, y, style, "ray", stx.chart.context, true, { pattern: "dashed", width: 0.1 } );

                    // Label
                    if (y > stx.chart.top && y < stx.chart.bottom) {
                        stx.endClip();
                        let label = askPrice;
                        if (panel.yAxis.priceFormatter)
                        label = panel.yAxis.priceFormatter(stx, panel, askPrice);
                        else label = stx.formatYAxisPrice(askPrice, panel);
                        stx.createYAxisLabel( panel, label, y, style.backgroundColor, "#ffffff" );
                        stx.startClip(panel.name);
                    }
                    stx.endClip();
                };

                stx.append("draw", drawAskLine);
                // stx.removeDrawings.push(drawAskLine);
            },
            getPl(list,instruments){
                return this.getProfitLoss(this.accountList.Currency, list, instruments, this.instruments)
            },
            getProfitLoss(accountCurrency, order, symbol, isins) {
                try {
                    if(symbol==undefined) return 0
                    else{
                        let quantity = order.Quantity;
                        let commission = parseFloat(order.Commission || 0);
                        let interest = parseFloat(order.Interest || 0);
                        let price = parseFloat(order.Price);
                        let askPrice = parseFloat(symbol.A);
                        let bidPrice = parseFloat(symbol.B);

                        let BSprice = order.Side === 1 ? bidPrice - price : price - askPrice;

                        let currencyConverter = this[product === 'Hanko' ? 'convertCurrencyHKT' : 'convertCurrencyNew'];
                        let convertedAmount = parseFloat(currencyConverter(accountCurrency, symbol, this.instruments, order.Side, order.Symbol));
                        
                        let toFixedValue = accountCurrency === 'BTC' ? 8 : 2;
                        let pnl = (BSprice * quantity * convertedAmount) + commission + interest;

                        return pnl.toFixed(toFixedValue);
                    }
                    
                } catch (e) {
                    // console.log(e);
                    return 0;
                }
            },
            convertCurrencyNew(accountCurrency, symbol, isins) {
                symbol.other.base_currency = symbol.other.base_currency.split('_V')[0];
                const base = symbol.other.base_currency;
                const acc = accountCurrency //.toUpperCase();
                const product = product_type; // assuming it's globally accessible

                if (acc === base) return 1;

                const getPossibleKeys = (cur1, cur2) => [
                    `${cur1}/${cur2}${product_type}`,
                    `${cur1}${cur2}.`,
                    `${cur1}${cur2}_`,
                    `${cur1}${cur2}${product_type}`
                ];

                const tryGetRateFromPairs = (cur1, cur2, invert = false) => {
                    if(cur1 == cur2) return 1;
                    const keys = getPossibleKeys(cur1, cur2);
                    if ((cur1 === 'BTC' && cur2 === 'USD') || (cur1 === 'USD' && cur2 === 'BTC')) keys.push('Bitcoin');
                    for (const key of keys) {
                        const item = isins[key];
                        if (item && item.A) return invert ? 1 / item.A : item.A;
                    }
                    return null;
                };

                // 1. Try direct and inverse rates
                let rate = tryGetRateFromPairs(acc, base, true) || tryGetRateFromPairs(base, acc, false);
                if (rate) return rate;

                // 2. Use USD as intermediary
                const toUSD = tryGetRateFromPairs(base, 'USD' + product) || tryGetRateFromPairs('USD', base + product, true);
                const fromUSD = 
                    tryGetRateFromPairs(acc, 'USD' + product, true) ||
                    tryGetRateFromPairs('USD', acc + product) ||
                    tryGetRateFromPairs(acc, product);

                if (fromUSD && toUSD) return ((toUSD == 1) ? toUSD/fromUSD : fromUSD * toUSD);

                // 3. Fallback using symbol directly
                const fallbackKey = acc + product;
                if (isins[fallbackKey]) {
                    return Number(symbol.A || 1) / Number(isins[fallbackKey].A || 1);
                }

                return 1; // final fallback
            },
            convertCurrency_old(accountCurrency, symbol, isins, side,orderSymbol){
            
                symbol.other.base_currency = symbol.other.base_currency.split('_V')[0]

                if(accountCurrency==symbol.other.base_currency){
                    return 1
                }else{
                    let isGet = false
                    const firstCurrency = accountCurrency.toUpperCase()+symbol.other.base_currency+""

                    if(isins[firstCurrency]){
                        return 1/isins[firstCurrency].A;
                        isGet = true;
                    }
                    
                    const firstCurrencyWithSlash = accountCurrency.toUpperCase()+symbol.other.base_currency+""
                    
                    if(isins[firstCurrencyWithSlash]){
                        return 1/isins[firstCurrencyWithSlash].A
                        isGet = true;
                    }
                    
                    const secondCurrency = symbol.other.base_currency+accountCurrency.toUpperCase()
                    
                    if(isins[secondCurrency]){
                        return isins[secondCurrency].A
                        isGet = true;
                    }
                    const secondCurrencyWithSlash = symbol.other.base_currency+accountCurrency.toUpperCase()+""
                    
                    if(isins[secondCurrencyWithSlash]){
                        return isins[secondCurrencyWithSlash].A
                        isGet = true;
                    }
                    let secontoUSD = 0
                    let accBasetoUSD = 0
                    if(isins[symbol.other.base_currency+"USD"+product_type]   ){
                        secontoUSD = isins[symbol.other.base_currency+"USD"+product_type].A
                        isGet = true;
                    } 
                    else if(isins['USD'+symbol.other.base_currency+product_type]){
                        secontoUSD = 1/isins['USD'+symbol.other.base_currency+product_type].A
                        isGet = true;
                    } 
                    
                    if(isins[accountCurrency.toUpperCase()+'USD'+product_type]){
                        accBasetoUSD = 1/isins[accountCurrency.toUpperCase()+'USD'+product_type].A
                        isGet = true;
                    } 
                    else if(isins['USD'+accountCurrency.toUpperCase()+product_type]){
                        accBasetoUSD = isins['USD'+accountCurrency.toUpperCase()+product_type].A
                        isGet = true;
                    }
                    else if(isins['USD'+accountCurrency.toUpperCase()+product_type]){
                        accBasetoUSD = isins['USD'+accountCurrency.toUpperCase()+product_type].A
                        isGet = true;
                    }
                    if(!isGet){
                        this.subscribeIsisn(firstCurrency)
                        this.subscribeIsisn(firstCurrencyWithSlash)
                        this.subscribeIsisn(secondCurrency)
                        this.subscribeIsisn(secondCurrencyWithSlash)
                        this.subscribeIsisn(symbol.other.base_currency+"USD"+product_type)
                        this.subscribeIsisn('USD'+symbol.other.base_currency+product_type)
                        this.subscribeIsisn(accountCurrency.toUpperCase()+'USD'+product_type)
                        this.subscribeIsisn('USD'+accountCurrency.toUpperCase()+product_type)
                    }
                    return accBasetoUSD * secontoUSD
                }
            },

            convertCurrencyHKT(accountCurrency, symbol, isins, side,orderSymbol){

                symbol.other.base_currency = symbol.other.base_currency

                if(accountCurrency==symbol.other.base_currency){
                    return 1
                }else{
                    let isGet = false
                    const firstCurrency = accountCurrency.toUpperCase()+symbol.other.base_currency+product_type

                    // console.log("firstCurrency", firstCurrency);

                    if(isins[firstCurrency]){
                        return 1/isins[firstCurrency].A;
                        isGet = true
                    }

                    const firstCurrencyWithSlash = accountCurrency.toUpperCase()+symbol.other.base_currency+product_type

                    if(isins[firstCurrencyWithSlash]){
                        return 1/isins[firstCurrencyWithSlash].A;
                        isGet = true;
                    }

                    const secondCurrency = symbol.other.base_currency+accountCurrency.toUpperCase()+product_type

                    

                    if(isins[secondCurrency]){
                        return isins[secondCurrency].A;
                        isGet = true;
                    }
                    const secondCurrencyWithSlash = symbol.other.base_currency+accountCurrency.toUpperCase()+product_type

                    if(isins[secondCurrencyWithSlash]){
                        return isins[secondCurrencyWithSlash].A;
                        isGet = true;
                    }
                    
                    //===============================if not found
                    let secontoUSD = 0
                    let accBasetoUSD = 0
                    if(isins[symbol.other.base_currency+"USD"+product_type]   ){
                        secontoUSD = isins[symbol.other.base_currency+"USD"+product_type].A
                        isGet = true;
                    } 
                    else if(isins['USD'+symbol.other.base_currency+product_type]){
                        secontoUSD = 1/isins['USD'+symbol.other.base_currency+product_type].A
                        isGet = true;
                    } 
                    
                    if(isins[accountCurrency.toUpperCase()+'USD'+product_type]){
                        accBasetoUSD = 1/isins[accountCurrency.toUpperCase()+'USD'+product_type].A
                        isGet = true;
                    } 
                    else if(isins['USD'+accountCurrency.toUpperCase()+product_type]){
                        accBasetoUSD = isins['USD'+accountCurrency.toUpperCase()+product_type].A
                        isGet = true;
                    }
                    else if(isins['USD'+accountCurrency.toUpperCase()+product_type]){
                        accBasetoUSD = isins['USD'+accountCurrency.toUpperCase()+product_type].A
                        isGet = true;
                    }
                    if(!isGet){
                        this.subscribeIsisn(firstCurrency)
                        this.subscribeIsisn(firstCurrencyWithSlash)
                        this.subscribeIsisn(secondCurrency)
                        this.subscribeIsisn(secondCurrencyWithSlash)
                        this.subscribeIsisn(symbol.other.base_currency+"USD"+product_type)
                        this.subscribeIsisn('USD'+symbol.other.base_currency+product_type)
                        this.subscribeIsisn(accountCurrency.toUpperCase()+'USD'+product_type)
                        this.subscribeIsisn('USD'+accountCurrency.toUpperCase()+product_type)
                    }
                    return accBasetoUSD * secontoUSD
                }
            },
            startDrag(tradeid, event) {
                this.draggedTradeId = tradeid;
                this.dragging = true;
                this.initialX = event.clientX - this.tradeData[tradeid].x;

                document.body.style.userSelect = 'none';
                document.addEventListener("mousemove", this.drag);
                document.addEventListener("mouseup", this.stopDrag);
            },
            drag(event) {
                if (this.dragging) {
                    const tradeid = this.draggedTradeId;
                    const chartContainer = document.querySelector('.chartContainer');
                    const containerRect = chartContainer.getBoundingClientRect();
                    
                    // Calculate new x position while staying within chartContainer bounds
                    let newX = event.clientX - this.initialX;
                    const tradeElement = document.getElementById(`drag_${tradeid}`);
                    const tradeWidth = tradeElement.offsetWidth;

                    // Check if the new X position is within bounds
                    if (newX < 0) newX = 0;
                    if (newX + tradeWidth > containerRect.width - 55) {
                        newX = containerRect.width - tradeWidth - 55;
                    }

                    this.tradeData[tradeid].x = newX;
                    tradeElement.style.left = this.tradeData[tradeid].x + 'px';
                }
            },
            stopDrag() {
                this.dragging = false;
                this.draggedTradeId = null;
                
                document.body.style.userSelect = '';
                document.removeEventListener("mousemove", this.drag);
                document.removeEventListener("mouseup", this.stopDrag);
            },
            closeTradeFromChart(tradeId){
                const orderData = this.openTradeList.find(orderData => orderData.TradeID === tradeId);
                if (orderData) {
                    this.closeTrade(orderData);
                    const elementToRemove = tradeId;
                    if (this.plotted.includes(elementToRemove)) {
                        this.plotted.splice(this.plotted.indexOf(elementToRemove), 1);
                    }
                    this.closedManually.push(tradeId)
                }
            },
            drawLine(price, side, pattern, quantity){
                let order = {
                    'solid':'Open Trade',
                    'dashed':'Pending Order'
                }
                let sideType = {
                    1: 'Buy',
                    0: 'Sell',
                }
                // console.log(price, side, pattern)
                const _her = this
                // CIQ.ChartEngine.prototype.append("draw", function(){
                    // do something here
                    const parameters={
                        'pattern': pattern,     // options: "solid","dashed","dotted"
                        lineWidth: 1.2 ,          // select any with for the line
                    };
                    //99
                    // const x = this.stxx.pixelFromDate('2016/02/15', this.stxx.chart);
                    const x=_her.stxx.pixelFromDate(_her.stxx.chart.dataSet[_her.stxx.chart.dataSet.length-1].Date, _her.stxx.chart);
                    const y= _her.stxx.pixelFromPrice(price, _her.stxx.chart.panel,_her.stxx.chart.yAxis)

                    const color = (parseInt(side)==0)?"red":"green";        // select any color 
                    const type = "horizontal"; // don't change this setting since we are interested in drawing a horizontal line only with a _her on the y-axis
                    _her.stxx.plotLine(x, x+1, y, y, color, type, _her.stxx.chart.context, true, parameters,2,1,'',true);
                    
                    /************* write a message under the last price ****************/
                    var context = _her.stxx.chart.context;
                    // write text
                    context.font = '12pt Calibri';
                    context.fillStyle = "white";
                    context.fillText(`${sideType[side]} @${price} ${quantity} Lot`, x - 280, y + 10);
                    // context.fillText(`${order[pattern]} for ${sideType[side]} ${quantity} Lots at ${price}`, x - 280, y + 10);
                // })
            },
            changeTheme(){
                if(localStorage.getItem("app-theme") == 'light-theme'){
                    if(localStorage.getItem("CIQ.Themes.prototype.current") != '{"theme":"ciq-day"}')
                        localStorage.setItem('CIQ.Themes.prototype.current','{"theme":"ciq-day"}');
                }else{
                    if(localStorage.getItem("CIQ.Themes.prototype.current") != '{"theme":"ciq-night"}')
                        localStorage.setItem('CIQ.Themes.prototype.current','{"theme":"ciq-night"}');
                }
            },
            subscribeISINS(isin){
                let _that = this
                try{
                    this.$store.getters[Const.GET_PROVIDERS]['priceFeed'].seeders['S_PF_PF'].watchlist([isin])
                }catch(e){
                    var interval = setTimeout(function(){
                        _that.subscribeISINS(isin)
                    }, 500)
                }
            },
            quotefeed(){
                let _that = this
                var quoteFeedSimulator  = {}; // the quotefeed object
                // local, non-dependent implementation of XmlHttpRequest
                quoteFeedSimulator.postAjax = function (url, cb) {
                    var server = new XMLHttpRequest();
                    url += (url.indexOf("?") === -1 ? "?" : "&") + new Date().getTime();
                    server.open("GET", url);
                    server.onload = function () {
                        cb(this.status, this.responseText);
                    };
                    server.onerror = function () {
                        cb(500);
                    };
                    server.send();
                };
                quoteFeedSimulator.maxTicks = 200;
                quoteFeedSimulator.url = process.env.LIVE_CHART_URL;
                if(this.$store.getters[Const.GET_PROVIDERS]['priceFeed'].settings.patchers.SecurityMasterPatcher.DW_HOST){
                    quoteFeedSimulator.url = this.$store.getters[Const.GET_PROVIDERS]['priceFeed'].settings.patchers.SecurityMasterPatcher.DW_HOST+"/api/provider/charting";
                }
                quoteFeedSimulator.getInteval = function(period,interval){
                    if(interval === 'minute'){
                        return `${period}m`;
                        // return `1m`;
                    }else{
                        return`${period}${interval}`;
                    }
                }
                quoteFeedSimulator.getCount = function(start,end,period,interval){
                    if(interval === 'minute'){
                        const startTime = moment(start);
                        const endTime = moment(end);
                        let count = Math.abs(parseInt((startTime.diff(endTime, 'minutes')/period).toFixed()));
                        return count?`&count=${count}`:'';
                    }else{
                        return '';
                    }
                }
                quoteFeedSimulator.fetchInitialData = function ( symbol, suggestedStartDate, suggestedEndDate, params, cb ) {
                    let currencyPairs = _that.currencyPairs.find(v=> v.mn == symbol) || {};
                    // console.log('------------>',symbol,_that.loadChart,_that.mn)
                    if(!currencyPairs && _that.stxx){
                        _that.stxx.loadChart(_that.lastIsin || _that.currency_pair);
                        symbol = _that.lastIsin || _that.currency_pair
                        // return;
                    }
                    currencyPairs = _that.currencyPairs.find(v=> v.mn == symbol) || {};
                    if(_that.lastIsin != symbol){
                        _that.lastIsin = symbol;
                        _that.$emit('changeChart', symbol)
                        let lastIsin = _that.currencyPairs.find(v=>v.mn == _that.lastIsin)
                        if(lastIsin){
                            _that.$emit('changeChart', symbol)
                        }else{
                            let subList = localStorage.getItem('subList')
                            subList = JSON.parse(subList)
                            if(subList && subList.length > 0){
                                let isin = subList[0];
                                if(_that.mn == isin){
                                    setTimeout(()=>{
                                        _that.stxx.loadChart(isin);
                                    })
                                }else{
                                    _that.$emit('changeChart', isin);
                                }
                            }
                        }
                    }
                    let price_detail = _that.instruments[symbol] || {};
                    if(price_detail.other){
                        CIQ.ChartEngine.YAxis.prototype.decimalPlaces = ((price_detail.other.Tick_Size || '').split('.')[1] || '').length
                    }else if(currencyPairs.mn){
                        CIQ.ChartEngine.YAxis.prototype.decimalPlaces = (currencyPairs.market_ContractSize).length-1
                    }else if(!currencyPairs.mn){
                        let pair = _that.currencyPairs.find(v=>v.mn == _that.currency_pair)
                        if(pair){ currencyPairs = pair; }
                    }
                    if(params.interval == 'second'){
                        return;
                    }
                    _that.showLine = true;
                    var self = this;
                    let startdate = moment.utc(suggestedStartDate).format('YYYYMMDDHHmm');
                    let enddate;
                    if(product == 'Capital-Street'){
                        enddate = moment.utc(_that.formatDateT(price_detail.T)).format('YYYYMMDDHHmm');
                    }else{
                        enddate = moment.utc(suggestedEndDate).format('YYYYMMDDHHmm');
                    }
                    // let enddate = moment.utc(suggestedEndDate).format('YYYYMMDDHHmm');
                    _that.timeFrame = self.getInteval(params.period,params.interval);
                    var queryUrl = `${self.url}?isin=${symbol}&startdate=${startdate}&enddate=${enddate}&interval=${self.getInteval(params.period,params.interval)}`+
                                    `${quoteFeedSimulator.getCount(suggestedStartDate,suggestedEndDate,params.period,params.interval)}`;
                    // console.log('----symbol---',queryUrl)
                    self.postAjax(queryUrl, function (status, response) {
                        // process the HTTP response from the datafeed
                        if (status === 200) {
                            // if successful response from datafeed
                            var newQuotes = self.formatChartData(response, symbol);
                            // CIQ.TFC.prototype.renderTrades();
                            // CIQ.Account.prototype.renderTrades();
                            // console.log(CIQ.TFC.prototype)
                            cb({
                                quotes: newQuotes,
                                moreAvailable: true,
                                attribution: { source: "simulator", exchange: "RANDOM" }
                            }); // return the fetched data; init moreAvailable to enable pagination
                        } else {
                            // else error response from datafeed
                            cb({ error: response ? response : status }); // specify error in callback
                        }
                    });
                };
                // called by chart to fetch update data
                quoteFeedSimulator.fetchUpdateData = function (symbol, startDate, params, cb) {
                    /*if(_that.timer != 0){
                        cb({
                            quotes: [],
                            attribution: { source: "simulator", exchange: "RANDOM" }
                        });
                    }else{*/
                        // _that.timer += 1
                        let price_detail = _that.instruments[symbol] || {};
                        if(params.interval == 'second'){ return; }
                        var self = this;
                        let sdate;
                        if(product == 'Capital-Street'){
                            sdate = moment.utc(_that.formatDateT(price_detail.T)).format('YYYYMMDDHHmm');
                        }else{
                            sdate = moment.utc(startDate).format('YYYYMMDDHHmm');
                        }
                        let edate = null;
                        // var queryUrl = self.url + "?isin=" + symbol + "&startdate=" + startDate + "&interval=" + params.interval + "&count=" + params.period;
                        var queryUrl = `${self.url}?isin=${symbol}&startdate=${sdate}&interval=${self.getInteval(params.period,params.interval)}`;
                        // if(self.getInteval(params.period,params.interval) == '1m' && _that.timer == 10){
                        if(_that.prevTime != sdate && params.interval == 'minute'){
                            let period = params.period*3
                            edate = moment()/*.utc(startDate)*/.subtract(period, 'minutes').format('YYYYMMDDHHmm')
                            queryUrl = `${self.url}?isin=${symbol}&startdate=${sdate}&enddate=${edate}&interval=${self.getInteval(params.period,params.interval)}&count=3`;
                            // _that.timer == 0
                        }
                        _that.prevTime = sdate
                        self.postAjax(queryUrl, function (status, response) {
                            // process the HTTP response from the datafeed
                            // let price_detail = _that.instruments[symbol] || {};
                            if (status === 200) {
                                // if successful response from datafeed
                                let close = null;
                                try{
                                    // var feeddata = JSON.parse(response);
                                    // feeddata = feeddata.data
                                    // if(feeddata[0].high >= parseFloat(price_detail.B) && feeddata[0].low <= parseFloat(price_detail.B) )
                                    close = price_detail.B ;
                                }catch(e){console.log(e)}
                                const newQuotes = self.formatChartData(response, symbol,parseFloat(close));
                                /*if(newQuotes.length == 0){
                                    _that.timer = 0
                                }*/
                                // if(newQuotes.length == 0){
                                //     let data = _that.stxx.chart.dataSet[_her.stxx.chart.dataSet.length-1]
                                //     if(data){
    
                                //     }
                                // }
                                // console.log('price_detail================>',newQuotes[0].Close,price_detail.A,newQuotes)
                                // newQuotes[0].Close = price_detail.A || newQuotes[0].Close;
                                // console.log(newQuotes)
                                if(price_detail.B && price_detail.A && newQuotes.length){
                                    // console.log(price_detail.other.Tick_Size)
                                    // CIQ.ChartEngine.YAxis.prototype.decimalPlaces = ( ((price_detail.other.Tick_Size || '').split('.')[1] || '').length )
                                    newQuotes[newQuotes.length-1].Ask = parseFloat(price_detail.B)
                                    newQuotes[newQuotes.length-1].Bid = parseFloat(price_detail.A)
                                }
                                newQuotes.reverse()
                                cb({
                                    // quotes: newQuotes.length ? [(newQuotes[newQuotes.length - 1])] : null,
                                    // quotes: newQuotes.length ? [(newQuotes[0])] : [],
                                    quotes: newQuotes,
                                    attribution: { source: "simulator", exchange: "RANDOM" }
                                }); // return the fetched data
                                if(newQuotes.length > 1){
                                    // console.log(newQuotes)
                                    let l = _that.stxx.chart.dataSet.length
                                    newQuotes.forEach((v,i)=>{
                                        if(i != 0){
                                            try{
                                                _that.stxx.updateChartData({ 'Date':v.Date, 'Open':v.Open, 'High':v.High, 'Low':v.Low, 'Close':v.Close })
                                            }catch(e){ }
                                        }
                                    })
                                }
                            } else {
                                // else error response from datafeed
                                cb({ error: response ? response : status }); // specify error in callback
                            }
                        });
                    // }
                    // console.log('==============--->',_that.timer)
                    // _that.timer += 1
                    // if(_that.timer == 120){
                    //     _that.timer = 0;
                    // }
                };
                // called by chart to fetch pagination data
                quoteFeedSimulator.fetchPaginationData = function ( symbol, suggestedStartDate, suggestedEndDate, params, cb) {
                    if(params.interval == 'second'){
                        return;
                    }
                    var self = this;
                    let startdate = moment.utc(suggestedStartDate).format('YYYYMMDDHHmm');
                    let enddate = moment.utc(suggestedEndDate).format('YYYYMMDDHHmm');
                    // var queryUrl = self.url + "?isin=" + symbol + "&startdate=" + suggestedStartDate + "&enddate=" + endDate + "&interval=" + params.interval + "&count=" + params.period;
                    var queryUrl = `${self.url}?isin=${symbol}&startdate=${startdate}&enddate=${enddate}&interval=${self.getInteval(params.period,params.interval)}`+
                                    `${quoteFeedSimulator.getCount(suggestedStartDate,suggestedEndDate,params.period,params.interval)}`;
                    self.postAjax(queryUrl, function (status, response) {
                        // process the HTTP response from the datafeed
                        if (status === 200) {
                            // if successful response from datafeed
                            var newQuotes = self.formatChartData(response, symbol);
                            cb({
                                quotes: newQuotes,
                                // moreAvailable: suggestedStartDate.getTime() > 0,
                                moreAvailable: newQuotes.length > 0,
                                upToDate: suggestedEndDate.getTime() > Date.now(),
                                attribution: { source: "simulator", exchange: "RANDOM" }
                            }); // return fetched data (and set moreAvailable)
                        } else {
                            // else error response from datafeed
                            cb({ error: response ? response : status }); // specify error in callback
                        }
                    });
                };
                // utility function to format data for chart input; given simulator was designed to work with library, very little formatting is needed
                // symbol argument can be used to further refine simulated data
                quoteFeedSimulator.formatChartData = function (response, symbol, close) {
                    var feeddata = JSON.parse(response);
                    feeddata = feeddata.data
                    var newQuotes  = [];
                    // if(close && feeddata.length > 1){
                    //     console.log(newQuotes,response)
                    // }
                    let price_detail = _that.instruments[symbol] || {};
                    // let PSHFTA =  (price_detail.PSHFTA || 0), PSHFTB = (price_detail.PSHFTB || 0);
                    let PSHFTB = Number(_that.priceShift[symbol+'B'] || 0)
                    // console.log('price_detail==>',_that.priceShift,PSHFTB,price_detail);
                    let ticksize = ((price_detail.other.Tick_Size || '').split('.')[1] || '').length
                    let formatDigit = (v) => {
                        if(price_detail.other && price_detail.other.market_ContractSize){
                            let newP = Number((Number(v) + PSHFTB).toFixed(ticksize))
                            // console.log('-1',Number(v),newP,PSHFTB)
                            return newP
                        }else{
                            // console.log('-2')
                            return v;
                        }
                    }
                    for (var i = 0; i < feeddata.length; i++) {
                        var newQuote = {};
                        const utcTime = moment(feeddata[i].time);
                        let newClose = (close && formatDigit(feeddata[i].high || feeddata[i].highBid) >= parseFloat(close) && formatDigit(feeddata[0].low || feeddata[0].lowBid) <= parseFloat(close)?close:formatDigit(feeddata[i].close || feeddata[i].closeBid))
                        // newQuote.DT = utcTime.local(); // DT is a string in ISO format, make it a Date instance
                        newQuote.DT = utcTime; // DT is a string in ISO format, make it a Date instance
                        // newQuote.DT = new Date(feeddata[i].time); // DT is a string in ISO format, make it a Date instance
                        //Add priceshift for bid and ask
                        //.others.priceShiftBuy
                        newQuote.Open = formatDigit(feeddata[i].open || feeddata[i].openBid);
                        newQuote.High = formatDigit(feeddata[i].high || feeddata[i].highBid);
                        newQuote.Low = formatDigit(feeddata[i].low || feeddata[i].lowBid);
                        newQuote.Close = (feeddata.length == 0 || i == feeddata.length-1)?newClose:(formatDigit(feeddata[i].close || feeddata[i].closeBid)) /* || feeddata[i].close*/;
                        newQuote.Volume = feeddata[i].volume;
                        newQuotes.push(newQuote);
                    }
                    return newQuotes;
                };
                return quoteFeedSimulator;
            },
            getBalance(){
                let _that = this
                CIQ.Account.prototype.isForex = function (symbol){
                    return true;
                }
                /*CIQ.Account.Demo.prototype.fetchPositions = function (cb) {
                    this.positions = {
                        "GBPUSD":{quantity:600,basis:1.24097, price:1.25097, prevClose:1.25, currency:"USD"},
                        "EURUSD":{quantity:20,basis:1.25, price:1.25, prevClose:1.25, currency:"USD"},
                        "JPYUSD":{quantity:20,basis:1.25, price:1.25, prevClose:1.25, currency:"USD"},
                    };
                    cb(); return;
                };*/

                //Not required
                // CIQ.Account.Demo.prototype.fetchBalances = function (cb) {
                //     // this.currency = _that.accBalance.ACCOUNT_CURRENCY;
                //     // console.log('fetchBalances============>')
                //     this.currency = _that.accBalance.ACCOUNT_CURRENCY;
                //     let data = {
                //         "liquidity":Number(_that.accBalance.ACCOUNT_USABLE_MARGIN || 0),
                //         "unsettledCash":0,
                //         "cash":Number(_that.accBalance.ACCOUNT_USABLE_MARGIN || 0),
                //         "profitLoss":0,
                //         "buyingPower":Number(_that.accBalance.AMOUNT || 0)
                //     }
                //     this.balances = data;
                //     cb(); return;
                // };
                
                CIQ.Account.Demo.prototype.fetchOpenOrders = function (cb) {
                    let order = {};
                    _that.pendingOrderList.forEach((v,i)=>{
                        if(['EL','ES'].includes(v.Type)){
                            if(!order[v.Symbol]){
                                order[v.Symbol] = []
                            }
                            order[v.Symbol].push({
                                id: v.OrderID,
                                tradeid: v.AccountID,
                                action: v.Side == 1?"buy":"short",
                                quantity: _that.getQuantity(v),
                                ordertype: v.Type,
                                position_size : _that.userSettings.position_size,
                                // market_ContractSize : (_that.otherListObj[v.Symbol] || {}).market_ContractSize,
                                Quantity : v.Quantity,
                                tif: "",
                                [v.Type=='EL'?'limit':v.Type=='ES'?'stop':null] : (['EL','ES'].includes(v.Type)?v.Price:undefined)
                            })
                        }
                        else if(['L', 'S'].includes(v.Type)){
                            let order_index = _that.openTradeList.findIndex(v1=>v1.TradeID == v.ToClose)
                            if(order_index != -1){
                                if(!order[v.Symbol]){
                                    order[v.Symbol] = []
                                }
                                order[v.Symbol].push({
                                    id: v.OrderID,
                                    tradeid: v.AccountID,
                                    action: v.Side == 1?"buy":"short",
                                    quantity: _that.getQuantity(v),
                                    ordertype: v.Type,
                                    closingTradeId: v.ToClose,
                                    tif: "",
                                    [v.Type=='L'?'limit':v.Type=='S'?'stop':null] : (['L','S'].includes(v.Type)?v.Price:undefined)
                                })
                            }
                        }
                    })
                    this.openOrders = order;
                    cb(); return;
                };
                
                CIQ.Account.Demo.prototype.fetchTrades = function (cb) {
                    // console.log('fetchTrades============>',_that.openTradeList)
                    let trade = {}, positions = {};
                    _that.openTradeList.forEach(v=>{
                        if(!trade[v.Symbol]){ trade[v.Symbol] = [] }
                        let price_detail = _that.instruments[v.Symbol] || {};
                        trade[v.Symbol].push({
                            id: v.TradeID,
                            time: new Date(v.date+'Z').getTime(),
                            quantity: v.Side ? _that.getQuantity(v):(0 - _that.getQuantity(v)),
                            basis: v.Price,
                            Quantity: v.Quantity,
                            side: v.Side,
                            price: price_detail.A || v.Price,
                        });
                        /*if(v.Symbol == 'EURUSD'){
                            console.log(new Date(v.OpenTime+'Z'),v.OpenTime,trade[v.Symbol],v.date)
                        }*/
                    });
                    this.trades = trade 
                    // console.log('trade====================>',this.trades,_that.openTradeList)
                    for(let key in trade){
                        let price_detail = _that.instruments[key] || {};
                        const { totalQuantity, sumOfWeightedPrices, sumOfWeightedBasic } = trade[key].reduce((acc, trade) => {
                            acc.totalQuantity += trade.quantity; // Accumulate total quantity
                            acc.sumOfWeightedPrices += trade.quantity * trade.price; // Accumulate sum of (quantity * price)
                            acc.sumOfWeightedBasic += trade.quantity * trade.basis; // Accumulate sum of (quantity * price)
                            return acc;
                        }, { totalQuantity: 0, sumOfWeightedPrices: 0, sumOfWeightedBasic : 0 });
                        // console.log(key,sumOfWeightedBasic,(sumOfWeightedBasic / totalQuantity),sumOfWeightedPrices)
                        positions[key] = {
                            quantity: Number(totalQuantity.toFixed(5)),
                            basis: Number((sumOfWeightedBasic / totalQuantity).toFixed(5)),
                            price: Number((sumOfWeightedPrices / totalQuantity).toFixed(5)),
                            prevClose: Number(price_detail.A || (sumOfWeightedPrices / totalQuantity).toFixed(5))
                        }
                    }
                    this.positions = positions;
                    cb(); return;
                };
            },
            orderPlacement(){
                let _that = this
                CIQ.Account.Demo.prototype.placeOrder = function (tfc, order, cb) {
                    console.log('placeOrder======>',order)
                    if (order.constructor == Array) {
                        _that.placeOrder(order[0],tfc)
                        _that.placeOrder(order[1],tfc)
                    } else {
                        if (!this.openOrders[order.symbol]) this.openOrders[order.symbol] = [];
                        _that.placeOrder(order,tfc)
                    }
                    cb();
                };
            },
            placeOrder(order,tfc){
                const tempOrderId = new Date().getTime()
                let limit = ((order.oto || []).find(v=>v.limit) || {}).limit;
                let stop = ((order.oto || []).find(v=>v.stop) || {}).stop;
                let orderJson = {
                    'symbol' : order.symbol,
                    'quantity': order.quantity,
                    'side' : (order.action == 'buy')?1:0,
                    'stop' : stop || 0,
                    'limit' : limit || 0,
                    'trail' : 0,
                    "commentary" : "",
                    "tempOrderId" : tempOrderId,
                    "account_id": this.get_user.profile.act_account_id,
                    'localParams' : this
                }
                if (!order.limit && !order.stop) {
                    // market orders
                    // this.execute(order, tfc.getCurrentPriceForOrder(order.action));
                    console.log('Position order=============>',orderJson)
                    this.$store.getters[Const.GET_PROVIDERS]['priceFeed'].seeders['S_PF_PF'].placeOrder(orderJson)
                } else {
                    // orderJson.price = tfc.getCurrentPriceForOrder(order.action)
                    orderJson.price = order.stop || order.limit
                    console.log('Pending order=============>',orderJson)
                    this.$store.getters[Const.GET_PROVIDERS]['priceFeed'].seeders['S_PF_PF'].placepending(orderJson)
                }
            },
            orderReplacement(){
                let _that = this;
                CIQ.Account.Demo.prototype.replaceOrder = function (tfc, order, cb) {
                    //console.log('replaceOrder===================>',order)
                    for (var symbol in this.openOrders) {
                        var openOrders = this.openOrders[symbol];
                        for (var i = 0; i < openOrders.length; i++) {
                            var openOrder = openOrders[i];
                            if (order.id == openOrder.id) {
                                _that.modifyOrder(order,openOrders[i]);
                                /*=========================================*/
                                openOrder.limit = order.limit["new"];
                                openOrder.stop = order.stop["new"];
                                openOrder.tif = order.tif["new"];
                                openOrder.quantity = order.quantity["new"];
                                if (order.oto["new"]) {
                                    openOrder.oto = order.oto["new"];
                                } else {
                                    delete openOrder.oto;
                                }
                                if (openOrder.tradeid && this.trades[symbol]) {
                                    for (var t = 0; t < this.trades[symbol].length; t++) {
                                        var trade = this.trades[symbol][t];
                                        if (trade.id == openOrder.tradeid) {
                                            if (openOrder.stop) trade.protect.stop = openOrder.stop;
                                            else if (openOrder.limit) trade.protect.limit = openOrder.limit;
                                            break;
                                        }
                                    }
                                }
                                cb();
                                return;
                            }
                        }
                    }
                };
            },
            modifyOrder(order,old){
                if((old.limit && old.limit != order.limit["new"]) || (old.stop && old.stop != order.stop["new"]) || (old.quantity != order.quantity["new"])){
                    const tempOrderId = new Date().getTime() + '_Price_lot'
                    let orderJson = {
                        "order_id" : order.id,
                        "symbol" : order.symbol,
                        "quantity" : (order.quantity["new"] || old.quantity),
                        "price" : (order.limit["new"] || order.stop["new"] || order.limit || order.stop),
                        "tempOrderId" : tempOrderId,
                        'localParams' : this
                    }
                    this.$store.getters[Const.GET_PROVIDERS]['priceFeed'].seeders['S_PF_PF'].modifyOrder(orderJson)
                }
                /*if(this.order.SL.Price && !this.edit_stop){
                    this.cancleOrder(this.order.SL)
                    change = true
                }else if(this.stop && this.stop != this.order.SL.Price){
                    const tempOrderId = new Date().getTime() + '_stop'
                    let orderJson = {
                        "order" : this.order.OrderID,
                        "trade" : '',
                        "price" : parseFloat(this.stop),
                        "tempOrderId" : tempOrderId,
                        'localParams' : this
                    }
                    this.$store.getters[Const.GET_PROVIDERS]['priceFeed'].seeders['S_PF_PF'].placestop(orderJson)
                    change = true
                }
                if(this.order.Trail.Trail && !this.edit_trail){
                    this.cancleOrder(this.order.Trail)
                    change = true
                }else if(this.trail && this.trail != this.order.Trail.Trail){
                    const tempOrderId = new Date().getTime() + '_trail'
                    let orderJson = {
                        "order" : this.order.OrderID,
                        "trade" : '',
                        "trail" : parseFloat(this.trail),
                        "tempOrderId" : tempOrderId,
                        'localParams' : this
                    }
                    this.$store.getters[Const.GET_PROVIDERS]['priceFeed'].seeders['S_PF_PF'].placeTrail(orderJson)
                    change = true
                }
                if(this.order.TP.Price && !this.edit_limit){
                    this.cancleOrder(this.order.TP)
                    change = true
                }else if(this.limit && this.limit != this.order.TP.Price){
                    const tempOrderId = new Date().getTime() + '_limit'
                    let orderJson = {
                        "order" : this.order.OrderID,
                        "trade" : '',
                        "price" : parseFloat(this.limit),
                        "tempOrderId" : tempOrderId,
                        'localParams' : this
                    }
                    this.$store.getters[Const.GET_PROVIDERS]['priceFeed'].seeders['S_PF_PF'].placeLimit(orderJson)
                    change = true
                }
                if(!change){
                    // console.log('please change before Modify Order')
                    useToast().error('Please Make changes before Modify Order',{ timeout: 2000 });
                    return
                }*/
            },
            closeOpenOrder(){
                let _that = this
                CIQ.Account.Demo.prototype.cancelOrder = function (tfc, order, cb) {
                    for (var symbol in this.openOrders) {
                        var openOrders = this.openOrders[symbol];
                        for (var i = 0; i < openOrders.length; i++) {
                            var openOrder = openOrders[i];
                            if (order.id == openOrder.id) {
                                _that.cancleOrder(order.id)
                                /*if (openOrder.tradeid && this.trades[symbol]) {
                                    for (var t = 0; t < this.trades[symbol].length; t++) {
                                        var trade = this.trades[symbol][t];
                                        if (trade.id == openOrder.tradeid) {
                                            if (openOrder.stop) delete trade.protect.stop;
                                            else if (openOrder.limit) delete trade.protect.limit;
                                            if (!trade.protect.stop && !trade.protect.limit)
                                                delete trade.protect;
                                            break;
                                        }
                                    }
                                }*/
                                openOrders.splice(i--, 1);
                            } else if (order.id == openOrder.oco) {
                                openOrder.oco = null;
                            }
                        }
                    }
                    cb();
                };
            },
            cancleOrder(id){
                const tempOrderId = new Date().getTime()
                let orderJson = {
                    "order_id" : id,
                    "tempOrderId" : tempOrderId,
                    'localParams':this
                }
                this.$store.getters[Const.GET_PROVIDERS]['priceFeed'].seeders['S_PF_PF'].cancelOrder(orderJson)
            },
            closePositions(){
                let _that = this;
                CIQ.Account.Demo.prototype.closeAllPositions = function (tfc, cb) {
                    console.log('close-closeAllPositions-------->')
                    for(var index in _that.openTradeList){
                        _that.closeTrade(_that.openTradeList[index]);
                    }
                    /*this.positions = {};
                    this.trades = {};
                    for (var symbol in this.openOrders) {
                        var openOrders = this.openOrders[symbol];
                        for (var i = 0; i < openOrders.length; i++) {
                            if (openOrders[i].tradeid) {
                                openOrders.splice(i--, 1);
                            }
                        }
                    }*/
                    cb();
                };

                CIQ.Account.Demo.prototype.closePosition = function (tfc, position, cb) {
                    console.log('close-closePosition-------->',position)
                    for(var index in _that.openTradeList.filter(v=>v.Symbol == position.symbol)){
                        _that.closeTrade(_that.openTradeList[index]);
                    }
                    /*var trades = this.trades[position.symbol];
                    for (var i = 0; i < trades.length; i++) {
                        var openOrders = this.openOrders[position.symbol];
                        if (openOrders) {
                            for (var j = 0; j < openOrders.length; j++) {
                                if (openOrders[j].tradeid == trades[i].id) {
                                    openOrders.splice(j--, 1);
                                }
                            }
                        }
                    }
                    delete this.trades[position.symbol];
                    delete this.positions[position.symbol];*/
                    cb();
                };

                CIQ.Account.Demo.prototype.closeTrade = function (tfc, trade, cb) {
                    console.log('close-trade-------->',trade)
                    let position = _that.openTradeList.filter(v=>v.TradeID == position.id) || []
                    if(trade.TradeID){
                        _that.closeTrade(position);
                    }
                    /*var trades = this.trades[trade.symbol];
                    for (var i = 0; i < trades.length; i++) {
                        if (trades[i].id == trade.id) {
                            trades.splice(i--, 1);
                            break;
                        }
                    }
                    var position = this.positions[trade.symbol];
                    if (position.quantity == trade.quantity) {
                        delete this.positions[trade.symbol];
                    } else {
                        position.basis = (
                            (position.quantity * position.basis - trade.quantity * trade.basis) /
                            (position.quantity - trade.quantity)
                        ).toFixed(2);
                        position.quantity -= trade.quantity;
                    }
                    var openOrders = this.openOrders[trade.symbol];
                    if (openOrders) {
                        for (i = 0; i < openOrders.length; i++) {
                            if (openOrders[i].tradeid == trade.id) {
                                openOrders.splice(i--, 1);
                            }
                        }
                    }*/
                    cb();
                };
            },
            closeTrade(item){
                const tempOrderId = new Date().getTime()
                let orderJson = {
                    "symbol" : item.Symbol,
                    "trade" : item.TradeID,
                    "quantity" : item.Quantity,
                    "tempOrderId" : tempOrderId,
                    'localParams':this
                }
                this.tempOrderId.push(tempOrderId)
                this.$store.getters[Const.GET_PROVIDERS]['priceFeed'].seeders['S_PF_PF'].closeTrade(orderJson);
            },
            successWs(){
                setTimeout(()=>{
                    // console.log(_that.stxx.tfc)
                    try{
                        /*if(this.stxx.tfc._isOpen){
                            this.stxx.tfc.updateData();
                        }*/
                    }catch(e){
                        console.log('error==>',e)
                    }
                }, 2000)
            },
            failedWs(){},
            displayError(getMessage,type){
                this.$notify({
                    group: 'foo',
                    type: (type && type == null)?'error':type,
                    text: getMessage,
                    duration: 4000,
                    closeOnClick: true
                });
            },
            getTradeQty(trade){
                let lotBy = 100000
                try{
                    lotBy = ((this.instruments[this.lastIsin] || {}).other || {}).market_ContractSize || 10000
                }catch(e){ }
                if(this.userSettings.position_size && this.userSettings.position_size == '1'){
                    return `Units ${trade.qty}`;
                }else{
                    return `Lot ${trade.qty?Math.round((trade.qty / lotBy) * 100) / 100:0}`;
                }
                
            },
            getQuantity(list){
                let lotBy = 100000
                try{
                    // lotBy = this.currencyPairs.filter(val=>val.isinid.includes(list.Symbol))[0].market_ContractSize || 100000
                    lotBy = ((this.instruments[list.Symbol] || {}).other || {}).market_ContractSize || 10000
                }catch(e){
                    console.log("ex", e)
                }
                if(this.userSettings.position_size && this.userSettings.position_size == '0'){
                    return list.Quantity
                }else{
                    const qty = list.Quantity?(list.Quantity / lotBy):0;
                    return Math.round(qty * 100) / 100;
                }
            },
           
            createChart(){
                try{

                let _that = this
                this.getBalance();
                this.orderPlacement();
                this.orderReplacement();
                this.closeOpenOrder();
                this.closePositions();
                const config = getDefaultConfig({
                    markerFeed: marker.MarkersSample,
                    scrollStyle: PerfectScrollbar,
                    scroll : 92,
                    maxTicks : 137,
                    emojiPicker: EmojiPopover,
                    quoteFeed: this.quotefeed(),
                    nameValueStore: CIQ.NameValueStore,
                    // forecastQuoteFeed: forecastfeed,
                });
                config.enabledAddOns = {
                    animation: true,
                    inactivityTimer: true,
                    rangeSlider: true,
                    shortcuts: true,
                    tableView: true,
                    tooltip: true
                };
                // config.addOns.tableView.coverContainer = ".ciq-chart-area";
                config.initialSymbol = {
                    symbol: this.currency_pair,
                    name: this.currency_pair,
                    exchDisp: "Forex"
                };
                let stxx = config.createChart();
                // console.log('------------->', stxx)
                if(this.$route.name != 'chart-iq'){
                    document.querySelector('.ciq-studies').click();
                }
                if(this.$route.query.isin){
                    stxx.loadChart(this.$route.query.isin.toUpperCase());
                }
                
                
                // startActiveTrader(stxx);
                // stxx.setTimeZone("America/New_York");
                // stxx.setTimeZone("Asia/Hong_Kong");
                stxx.chart.xAxis.adjustTimeZone=false
                // stxx.setTimeZone("Asia/Kolkata");
                stxx.chart.maxTicks = 120;
                // stxx.chart.allowScrollFuture=false;
                // CIQ.ChartEngine.YAxis.prototype.decimalPlaces=5;
                let price_detail = _that.instruments[this.currency_pair] || {};
                let currencyPairs = this.currencyPairs.find(v=> v.mn == this.currency_pair) || {};
                if(price_detail.other){
                    CIQ.ChartEngine.YAxis.prototype.decimalPlaces = ((price_detail.other.Tick_Size || '').split('.')[1] || '').length
                }else if(currencyPairs.mn){
                    CIQ.ChartEngine.YAxis.prototype.decimalPlaces = (currencyPairs.market_ContractSize).length-1
                }
                // stxx.soloPanelToFullScreen = true;
                this.stxx = stxx;
                stxx.addEventListener("drawing", this.trackDrawingsEvent);
                // stxx.addEventListener("layout", this.myChartLayoutTest);
                // console.log('here we are in create chart', this.currency_pair)
                
                const originalStorePreferences = CIQ.NameValueStore.prototype.set;

                    // Override `set` to capture when a view is saved
                    CIQ.NameValueStore.prototype.set = function (key, value, cb) {
                        // console.log("Saving view:", key, value);
                        // console.log('here we are in create fucntion of chart iq.vue',stxx.chart.symbol)
                        // const newSymbol = stxx.chart.symbol;
                        // stxx.loadChart(newSymbol, {}, () => {
                        //         // Retrieve and apply saved drawings
                        //         const savedDrawings = localStorage.getItem(`${newSymbol}`);
                        //         console.log('we are reload the savedDrawings', savedDrawings)
                        //         if (savedDrawings) {
                        //             stxx.importDrawings(JSON.parse(savedDrawings));
                        //         }
                        //     });
                        // if (key.startsWith("stxView")) {  // Ensures it's a saved chart view
                        //     localStorage.setItem("lastSavedView", JSON.stringify(value));
                        //     alert(`Saved view "${key}" successfully!`);
                        // }

                        originalStorePreferences.apply(this, arguments);
                    }
                // stxx.addSeries("Bid", { color:'blue'});
                // stxx.addSeries("Ask", { color:'yellow'});
                // stxx.addSeries('ge',{renderer:'Candles',shareYAxis:true});
                // stxx.addSeries('geBid',{display:'Ge Bid',symbol:'ge',field:'Bid',color:'yellow',renderer:'Lines',shareYAxis:true});
                // stxx.addSeries('geAsk',{display:'Ge Ask',symbol:'ge',field:'Ask',color:'blue',renderer:'Lines',shareYAxis:true});
                window.myStxx = this.stxx 
                new CIQ.InactivityTimer({stx:stxx, minutes:30, interval:15 , wakeCB : this.wakeCB, sleepCB : this.sleepCB });

                let previousCustomThemes = JSON.parse(localStorage.getItem("CIQ.Themes.prototype.custom") || "{}");
                let themeChangeTimeout;
                let prevTheme = '';
                const changeTheme = () => {
                    clearTimeout(themeChangeTimeout);
                    themeChangeTimeout = setTimeout(()=>{
                        let currentTheme = localStorage.getItem("CIQ.Themes.prototype.current");
                        const customThemes = JSON.parse(localStorage.getItem("CIQ.Themes.prototype.custom") || "{}");
                        currentTheme = JSON.parse(currentTheme || {});
                        let is_chage = false;
                        // _that.bgColor = '' ;
                        // _that.textColor = '';
                        if(currentTheme.theme != prevTheme){
                            prevTheme = currentTheme.theme;
                            is_chage = true
                        }
                        if(currentTheme.theme && ['ciq-night','ciq-day'].includes(currentTheme.theme) && is_chage){
                            const greenColor = getComputedStyle(document.body).getPropertyValue('--green-color').trim();
                            const redColor = getComputedStyle(document.body).getPropertyValue('--red-color').trim();
                            let bgColor = getComputedStyle(document.body).getPropertyValue('--secondary-color').trim();
                            _that.stxx.setStyle("stx_candle_up", "color", greenColor);
                            _that.stxx.setStyle("stx_candle_down", "color", redColor);
                            _that.stxx.setStyle("stx_candle_up", "borderLeftColor", greenColor);
                            _that.stxx.setStyle("stx_candle_down", "borderLeftColor", redColor);
                            _that.stxx.setStyle("stx_candle_up", "borderRightColor", greenColor);
                            _that.stxx.setStyle("stx_candle_down", "borderRightColor", redColor);
                            _that.stxx.setStyle("stx_candle_shadow_up", "color", greenColor);
                            _that.stxx.setStyle("stx_candle_shadow_down", "color", redColor);
                            try{
                                ['.ciq-nav', '.ciq-footer'].forEach(sel => document.querySelectorAll(sel).forEach(el => el.style.background = '') );
                            }catch(e){}
                            if(currentTheme.theme == 'ciq-night'){
                                // console.log('---------->',_that.appTheme )
                                if(!_that.appTheme){
                                    bgColor = getComputedStyle(document.body).getPropertyValue('--DARK-bg').trim();
                                    try{
                                        ['.ciq-nav', '.ciq-footer'].forEach(sel => document.querySelectorAll(sel).forEach(el => el.style.background = 'var(--black-color)') );
                                    }catch(e){}
                                    // console.log('----bgColor------>',bgColor)
                                }
                                _that.stxx.container.style.backgroundColor = bgColor;
                                _that.stxx.canvasStyle("backgroundColor", bgColor);
                            }
                            _that.stxx.draw();
                        }
                        if(!isEqual(customThemes,previousCustomThemes)){
                            previousCustomThemes = customThemes;
                            _that.saveTheme()
                        }
                        // console.log(customThemes,previousCustomThemes)
                        // console.log(isEqual(customThemes,previousCustomThemes))
                    }, 100)
                }
                setInterval(()=>{
                    const customThemes = JSON.parse(localStorage.getItem("CIQ.Themes.prototype.custom") || "{}");
                    if(!isEqual(customThemes,previousCustomThemes)){
                        previousCustomThemes = customThemes;
                        this.saveTheme()
                    }
                },2000)
                this.stxx.addEventListener("theme", () =>  changeTheme() );
                this.stxx.addEventListener("periodicity", () =>  _that.plotted = [] );
                setTimeout(()=>{
                    if(_that.$route.name != 'chart-iq' && !['Copyrack1'].includes(product)){
                        document.querySelector("cq-toggle.sidebar.stx-trade").click();
                    }else{
                        // document.querySelector("cq-toggle.sidebar.stx-trade").click();
                        document.querySelector('.ciq-screen-reader').click();
                        // document.querySelector("cq-toggle.sidebar.stx-trade").click();
                    }
                    // console.log(stxx.tfc)
                    // CIQ.TFC.openPanel();
                    // stxx.tfc.openPanel()
                    _that.addPlusIconToCrosshair(_that.stxx)
                    _that.drawTradeLines();

                    /*if(this.product == "Capital-Street") {
                        //  market line colors
                        stxx.setStyle("stx_current_hr_up", "backgroundColor", greenColor);
                        stxx.setStyle("stx_current_hr_up", "borderColor", greenColor);
                        stxx.setStyle("stx_current_hr_down", "backgroundColor", redColor);
                        stxx.setStyle("stx_current_hr_down", "borderColor", redColor);

                        // chart candles colors 
                        stxx.setStyle("stx_candle_up", "color", greenColor); // Green for up candles
                        stxx.setStyle("stx_candle_shadow_up", "color", greenColor);    // Green wick for up candles
                        stxx.setStyle("stx_candle_up", "borderLeftColor", greenColor);
                        stxx.setStyle("stx_candle_up", "borderRightColor", greenColor);
                        // Apply the changes
                        stxx.draw();
                    }*/
                    // stxx.addSeries("Ask", {color: "green", loadData: false, shareYAxis: false, step:true});
                    // stxx.addSeries("Bid", {color: "red", loadData: false, shareYAxis: false, step:true});
                },1000)
                /*setTimeout(()=>{
                    stxx.createYAxis({
                        name: "ASK_LINE",
                        value: 0,
                        color: "red",
                        lineWidth: 2,
                        parameters: {
                            pattern: "solid",
                            opacity: 9
                        }
                    });
                },4000)*/
                // stxx.setTheme('ciq-day');
                // CIQ.activateImports(quoteFeed, symbolLookupBase);
                /*CIQ.Account.Demo = function() {
                    this.currency = _that.accBalance.ACCOUNT_CURRENCY;
                }*/
                }catch(e){
                    console.log('error---------->', e)
                }
            },
            saveTheme(){
                let custom_theme = localStorage.getItem('CIQ.Themes.prototype.custom')
                custom_theme = JSON.parse(custom_theme || {});
                let obj = this.rawObject;
                if (typeof obj !== "object" || obj === null || Array.isArray(obj)) {
                    obj = {}; // fallback to empty object
                }
                const drawingData = Object.assign({}, obj, {
                    theme: custom_theme
                });
                try{
                    this._runSetRawObject({ 'globalParams' : {'setting': drawingData},'localParams' : {'parameter' : this} }) 
                } catch(e){
                    console.error("Error while updating drawings:", e);
                }
            },
            trackDrawingsEvent(params) {
                    if (!params.symbol || typeof params.symbol !== 'string' || params.symbol.trim() === '') {
                        console.error("Invalid symbol provided:", params.symbol);
                        return;
                    }
                    const allDrawings = this.stxx.exportDrawings() || [];
                    if(!Array.isArray(allDrawings)){
                        console.warn("Drawings are not an array");
                        return
                    }
                    let getPreviousDrawings = localStorage.getItem('previousDrawings')
                    let get_drawings = JSON.parse(localStorage.getItem('_drawings') || '{}')
                    get_drawings = normalizeKeys(get_drawings, ".", "#")

                    const drawKey = params.symbol
                    if(!!getPreviousDrawings){
                        this.previousDrawings = JSON.parse(getPreviousDrawings)
                    }
                    let drawingObj = {  
                        [drawKey]:allDrawings
                    }
                    // if there is existing drawing object
                    let updatePreviousDrawings = [...this.previousDrawings]
                        const isDrawingExist = updatePreviousDrawings.findIndex(draw => Object.keys(draw)[0] === drawKey)
                        if(isDrawingExist == -1 && allDrawings.length > 0){
                            updatePreviousDrawings.push(drawingObj)
                        }else {
                            allDrawings.length == 0 ? updatePreviousDrawings.splice(isDrawingExist, 1)
                            :
                            updatePreviousDrawings[isDrawingExist][drawKey] = [...allDrawings]
                        }

                      updatePreviousDrawings   = normalizeKeys(updatePreviousDrawings, ".", "#")
                        
                        this.previousDrawings = [...updatePreviousDrawings]
                        const drawingData = {
                            _drawings: get_drawings,
                            drawingIsins: [...updatePreviousDrawings],
                        }


                    let custom_theme = localStorage.getItem('CIQ.Themes.prototype.custom')
                    if (typeof custom_theme === 'string') { 
                        custom_theme = JSON.parse(custom_theme || {})
                        if (custom_theme && typeof custom_theme === 'object' && Object.keys(custom_theme).length) {
                            drawingData.theme = custom_theme;
                        }
                    }
                    let _that = this
                    try{
                        _that._runSetRawObject({ 'globalParams' : {'setting': drawingData},'localParams' : {'parameter' : this} }) 
                    } catch(e){
                        console.error("Error while updating drawings:", e);
                    }
            },
            addHashInKeys(data){
                let convertedObj = data
                if(Array.isArray(convertedObj)){
                    convertedObj.forEach((item) => {
                        for (const key in item) {
                            if (Object.prototype.hasOwnProperty.call(item, key)) {
                                if (key.includes("-")) {
                                    const newKey = key.replace(/-/g, "#"); // replace all dashes with #
                                    item[newKey] = item[key]; // copy value
                                    delete item[key]; // remove old key
                                }else{
                                    item[key] = item[key]; // copy value
                                }
                            }
                        }
                    })
                }
                for (const key in convertedObj) {
                        if (Object.prototype.hasOwnProperty.call(convertedObj, key)) {
                            if (key.includes("-")) {
                            const newKey = key.replace(/-/g, "#"); // replace all dashes with #
                            convertedObj[newKey] = convertedObj[key]; // copy value
                            delete convertedObj[key]; // remove old key
                            }
                        }
                }
                return convertedObj
            },
            sleepCB() {
                this.isSleep = true;
            },
            wakeCB() {
                if(this.isSleep && this.stxx){
                    this.isSleep = false;
                    let _that = this;
                    // this.stxx.destroy(); // Destroy the current chart instance
                    // this.stxx = null;
                    this.stxx.loadChart(_that.lastIsin);
                    // setTimeout(()=>{

                    //     _that.createChart(); // Reinitialize the chart
                    // },1000)
                }
            },
            addPlusIconToCrosshair(stxx) {
                const _that = this;
                this.stxx.layout.crosshair = true;
                var plusIcon = document.createElement("div");
                plusIcon.className = "crosshair-plus-icon";
                plusIcon.innerHTML = "+";
                plusIcon.style.display = "none";
                // document.body.appendChild(plusIcon);
                // const charScreeen = document.getElementById('charScreeen');
                const charScreeen = document.querySelector('.chartContainer');
                charScreeen.appendChild(plusIcon);

                let addTop = 106, rightClickTop = 35;
                if(this.$route.name == 'grid-view'){
                    addTop = 120;
                    rightClickTop = 95;
                }
                CIQ.ChartEngine.prototype.append("undisplayCrosshairs", function(){
                    // do something here
                    plusIcon.style.display = "none";
                    _that.rightClickWindow = false;
                });
                // Position the "+" icon at the crosshair's intersection point
                _that.stxx.addEventListener("move", function(cb) {
                    if (!_that.rightClickWindow) {
                        if (_that.stxx.layout.crosshair && _that.stxx.crosshairX !== null && _that.stxx.crosshairY !== null) {
                            // Get the chart container's bounding box
                            var rect = _that.stxx.chart.container.getBoundingClientRect();
                            // Position the plus icon at the crosshair's intersection point
                            // plusIcon.style.left = (rect.right - 80) + "px";
                            plusIcon.style.right = 60 + "px";
                            plusIcon.style.top = (_that.stxx.crosshairY + _that.stxx.crosshairYOffset / 2 - addTop + (window.innerWidth < 1461? 10 : 0)) + "px";
                            
                            _that.priceFromChart = _that.stxx.priceFromPixel(_that.stxx.crossYActualPos);

                            _that.rightClickWindowLeft = plusIcon.style.left;
                            _that.rightClickWindowTop = (_that.stxx.crosshairY + _that.stxx.crosshairYOffset / 2 - rightClickTop) + "px";
                            
                            plusIcon.style.display = "block";
                        } else {
                            plusIcon.style.display = "none";
                        }
                    }else{
                        plusIcon.style.display = "none";
                    }
                });

                // Add click event listener to the plus icon
                plusIcon.addEventListener('click', event => {
                    event.stopPropagation(); // Stop the event from bubbling up to the document
                    
                    const tickSizeParts = _that.instruments[_that.lastIsin].other.Tick_Size.split(".");
                    const precision = tickSizeParts[1] ? tickSizeParts[1].length : 0;

                    _that.priceFromChart=parseFloat(_that.priceFromChart).toFixed(precision)
                    
                    _that.rightClickWindow = !_that.rightClickWindow;
                    _that.addDraggableVerticalLine(parseFloat(_that.priceFromChart));
                    event.preventDefault();
                });

                document.addEventListener('click', event => {
                    _that.rightClickWindow = false;
                });

                document.getElementById("charScreeen").addEventListener('click', event => {
                    _that.rightClickWindow = false;
                });
            },

            openTrade(isin, price, orderType, buySellType){
                this.$emit('placeTrade', {"isin": isin, "price":price, "orderType":orderType, "buySellType":buySellType});
                this.rightClickWindow=false
            },

            addDraggableVerticalLine(price) {
                this.activeOrderType={};
                 // if current price is greater price buy stop
                // if current price is greater price sell limit
                // if current price is less price buy limit
                // if current price is less price sell stop
                const current_price = parseFloat(this.instruments[this.lastIsin].B)
                if(current_price < price){
                    this.activeOrderType["buy_stop"]={}
                    this.activeOrderType["buy_stop"]['orderType']= "S"
                    this.activeOrderType["buy_stop"]['buySellType']= "buy"
                    this.activeOrderType["buy_stop"]['name']="Buy Stop"

                    this.activeOrderType["sell_limit"]={}
                    this.activeOrderType["sell_limit"]['orderType']= "L"
                    this.activeOrderType["sell_limit"]['buySellType']= "sell"
                    this.activeOrderType["sell_limit"]['name']="Sell Limit"

                }else if(current_price > price){

                    this.activeOrderType["sell_stop"]={}
                    this.activeOrderType["sell_stop"]['orderType']= "S"
                    this.activeOrderType["sell_stop"]['buySellType']= "sell"
                    this.activeOrderType["sell_stop"]['name']="Sell Stop"

                    this.activeOrderType["buy_limit"]={}
                    this.activeOrderType["buy_limit"]['orderType']= "L"
                    this.activeOrderType["buy_limit"]['buySellType']= "buy"
                    this.activeOrderType["buy_limit"]['name']="Buy Limit"

                }
            },
            startChart(){
                let _that = this
                setTimeout(()=>{
                    if(_that.get_user.token || this.$route.name == 'chart-iq'){
                        let interval = setInterval(()=>{
                            let price_detail = _that.instruments[_that.currency_pair] || {};
                            if(CIQ && CIQ.Account && price_detail.B){
                                _that.createChart();
                                clearInterval(interval)

                                // const d = document.getElementById("charScreeen");
                                const d = document.querySelector('.chartContainer');
                                const leftPos = d.offsetLeft;
                                const topPos = d.offsetTop+46;
                                const belowPos = (topPos + d.offsetHeight)-65;
                                let y_distance = 30
                                TFC.prototype.plotOpenTrades = function (x, y, trade) {
                                    if(_that.closedManually.indexOf(trade.id)==-1 && window['myStxx'] && window['myStxx'].tfc && window['myStxx'].tfc._isOpen){
                                        if(y+y_distance<belowPos && y+y_distance>topPos ){
                                            if(_that.plotted.indexOf(trade.id)==-1){
                                                _that.tradeData[trade.id] = {"x": leftPos+10, "y": y+y_distance, 'qty' : trade.Quantity, 'comment' : _that.sideValue[trade.side] }
                                                _that.plotted.push(trade.id)
                                                // _that.tradeData[trade.id]["comment"]=_that.sideValue[trade.side]+" lot "+Math.abs(trade.quantity)
                                            }

                                            
                                            if (_that.tradeData && _that.tradeData[trade.id]) {
                                                _that.$set(_that.tradeData, trade.id, Object.assign({}, _that.tradeData[trade.id], {
                                                    y: y + y_distance,
                                                    qty: trade.Quantity
                                                }));
                                                if (document.getElementById(`drag_${trade.id}`)) {
                                                    document.getElementById(`drag_${trade.id}`).style.top = _that.tradeData[trade.id].y + 'px';
                                                }
                                            }
                                            
                                        }else{
                                            _that.plotted=[]
                                        }
                                    }else{
                                        
                                        if(window['myStxx'] && !(window['myStxx'].tfc._isOpen)){
                                            $(".open_trade_chart").remove();
                                            _that.plotted=[]
                                        }
                                        
                                    }
                                };
                                TFC.prototype.clearOpenTrades = function () {
                                    $(".open_trade_chart").remove();
                                    _that.plotted=[];
                                };
                            }
                        },500)
                    }
                },500)

            }
        },
        mounted() {
            let _that = this
            window.myStxx = null;
            var element = document.getElementById("ch-iq");
           
            if(localStorage.getItem("app-theme") == 'light-theme'){
                element.classList.add("ciq-day");
            }else{
                element.classList.add("ciq-night");
            }
            // this._runGetpriceShift({ globalParams: {}, localParams: { parameter: this } });
            this.startChart()
        },
        beforeUnmount(){
            // Destroy the ChartIQ instance
            if (this.stxx) {
                this.stxx.destroy();
                this.stxx = null; // Ensure no references remain
                this.$refs.chartContainer.innerHTML = "";
            }
        }
    }
</script>
<style>
    /* @import url('/static/website/chartiq/css/stx-chart.css');
    @import url('/static/website/chartiq/css/normalize.css');
    @import url('/static/website/chartiq/css/page-defaults.css');
    @import url('/static/website/chartiq/css/chartiq.css');
    @import url('/static/website/chartiq/css/webcomponents.css');
    @import url('/assets/js/chartiq/plugins/tfc/tfc.css'); */
</style>
<style>
    .crosshair-plus-icon {
        position: absolute;
        z-index: 99;
        width: 20px;
        height: 20px;
        background-color: #ffffff;
        color: #000000;
        border: 1px solid black;
        text-align: center;
        line-height: 18px;
        border-radius: 50%;
        cursor: pointer;
        box-shadow: 0 0 3px rgba(0, 0, 0, 0.3);
        pointer-events: auto;
    }
    .hanko-chartIQ *{
        box-sizing: content-box;
    }
    .hanko-chartIQ select{
        -webkit-appearance: auto;
    }
    .stx-head-bar h4{
        font-size: inherit;
    }
    #ch-iq input, textarea {
        caret-color: var(--black-color);
    }
    /* body[broker="act"] .ciq-night .ciq-nav,.stx-trade-panel {
        background: var(--secondary-color) !important;
    }
    body[broker="act"] .ciq-night .chartContainer {
        background: var(--primary-color) !important;
    }
    body[broker="Hanko"] .ciq-night{
        background: #1E2746;
    }
    body[broker="Hanko"] .ciq-night .stx-trade-panel{
        background: #1E2746;
    }
    body[broker="Hanko"] .ciq-night .ciq-nav{
        background: #1E2746;
    }
    body[broker="Hanko"] .ciq-night .ciq-footer{
        background: #1E2746;
    }
    body[broker="Hanko"] .ciq-night .chartContainer {
        background: #1E2746;
    }
    body[broker="Capital-Street"] .ciq-night .chartContainer {
        background: var(--secondary-color) !important;
    } */
    .ciq-night .ciq-nav{
        background: var(--secondary-color);
    }
    .multiGrid-page .multiGrid .splitTop .second-wishlist.chartIQ {
        width: 100%;
        height: calc(100% - 6%);
    }
    .multiGrid-page.active .multiGrid .splitTop .second-wishlist.chartIQ {
        height: calc(100% - 27%);
    }
    .inputTemplate.amount{
        display: none !important;
    }
    /*.demo-chart-iq cq-toggle.sidebar.stx-trade{
        display: none;
    }
    .tfc-market-section .click {
        height:  18px !important;
    }
    .tfc-bid , .tfc-ask, .inputTemplate.amount{
        display: none !important;
    }
     body[broker="Hanko"] cq-toggle.sidebar.stx-trade{
        display: none;
    } */
    /* body[broker="Copyrack"] cq-toggle.sidebar.stx-trade{
        display: none;
    } */
    .tfc.create-order{
        background-color: var(--secondary-color);
        border: 1px outset var(--white-color);
        color: var(--white-color) !important;
    }
    .tfc .stx-data{
        color: inherit !important;
    }
    .tfc .tfc-cancel-button.click,
    .tfc .tfc-cancel-button.click:hover{
        margin: 4px !important;
        /* background-color: var(--white-color); */
    }
    .stx-limit-order.tfc-cancel{
        height: auto !important;
    }
    html:not([ciq-last-interaction=touch]) .tfc.stx-oco-order{
        display: none;
    }
    .context-menu {
        position: absolute;
        background-color: black;
        border-radius: 5px;
        box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.5);
        padding: 10px;
        z-index: 1000;
        right: 50px;
    }

    .context-menu ul {
        list-style: none;
        margin: 0;
        padding: 0;
    }

    .context-menu li {
        padding: 5px 10px;
        color: white;
        cursor: pointer;
        font-size: var(--f-14);
    }

    .context-menu li:hover {
        background-color: #333;
    }
    .tfc .tfc-cancel-button.click{
        color: var(--white-color) !important;
    }
    .tfc.OTO .col2, .tfc.OTO .col3, .tfc.OTO .col2 .stx-data {
        color: var(--white-color) !important;
    }
    body .ciq-night .stx-btn.stx-ico>span,html:not([ciq-last-interaction=touch]) body .stx-btn.stx-ico:hover>span,body .stx-btn.stx-ico:active>span {
        background-position: -250px -50px !important;
    }
    cq-dropdown ul.content.ps {        
        height: auto;
        max-height: 250px !important;
    }
    #charScreeen.fullScreen {
        top: 0;
        left: 0;
        margin: 0px;
        height: 100vh;
        width: 100vw;
        position: fixed;
        /* z-index: 100; */
    }
    cq-dialog:not([cq-signaliq-dialog]){
        z-index: 10 !important;
    }
    cq-color-picker{ z-index: 11; }
    :host(cq-dropdown)[cq-lift], cq-dropdown[cq-lift]{ z-index: 11; }
</style>


// WEBPACK FOOTER //
// src/components/website/shared/chart-iq.vue